import Table from './Table'
import Collapsible from './Collapsible'

Object.assign(Table, {
  Collapsible
})

export default Table
